// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xo_a bhr_a bhr_x","StrollerDetailRating__muted":"xo_b bhr_fo"};